import { SET_ALL_SETTINGS} from '../types/types'

export const setAllSettings = (value) =>{
    return{
        type:SET_ALL_SETTINGS,
        payload:{data:value}
    }
}

